import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import LogoutIcon from '@mui/icons-material/Logout';
import { Avatar, Button } from '@mui/material';
import { deepOrange } from '@mui/material/colors';
import LogoEduk from '@/assets/images/LogoWhite.png';
import { useUserStore } from '@/stores/user.ts';
import TextHelper from '@/utils/TextHelper.ts';

const Header = () => {
  const { user } = useUserStore()

  const { logout } = useUserStore();
  const menuId = 'primary-search-account-menu';

  const handleLogout = () => {
    logout();
  };

  return (
    <Box sx={{ flexGrow: 1, '.MuiPaper-root': { position: 'fixed', zIndex: 3 } }}>
      <AppBar
        sx={{
          background:
            'linear-gradient(90deg, #E04A4C 7.72%, #09A75D 28.04%, #96C227 46.09%, #F6BE33 62.35%, #6F5096 79.95%, #A56EA5 94.4%);',
        }}
        position="static"
      >
        <Toolbar>
          <Box width={'200px'}>
            <IconButton disableRipple= {true}>
              <img width={'55px'} height={'55px'} src={LogoEduk} alt="" />
            </IconButton>

          </Box>
          <Typography variant="h6" noWrap component="div" sx={{ display: { xs: 'none', sm: 'block' } }}>
            Olá, {user?.username ? TextHelper.capitalized(user.username) : ''}!
          </Typography>

          <Box sx={{ flexGrow: 1 }} />
          <Box>
            <Button
              sx={{
                bgcolor: '#fff',
                color: '#E04A4C',
                maxWidth: '200px',
                p: '7.5px 16px',
                borderRadius: '24px',
                fontSize: '14px',
                border: '2px solid #E04A4C',
                fontWeight: 700,
                textTransform: 'none',
                '&:hover': {
                  bgcolor: '#E04A4C', 
                  color: '#fff',    
                  border: '2px solid #fff', 
                }
              }}
              variant="contained"
              onClick={handleLogout}
            >
              Sair
              <LogoutIcon sx={{ ml: '10px' }} />
            </Button>

            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              color="inherit"
            >
              <Avatar sx={{ bgcolor: deepOrange[100], color: '#E04A4C' }}>{user?.username?.charAt(0)?.toUpperCase()}</Avatar>
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
